import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const Inner = styled.div `
  @media ${from(Device.MobileLarge)} {
    ${baseGrid};
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-column-gap: 24px;
    grid-row-gap: 40px;
  }

  @media ${from(Device.Tablet)} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-column-gap: 36px;
    grid-row-gap: 60px;
  }

  @media ${from(Device.TabletLarge)} {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`;
export const CtaCardsStyles = {
    Container,
    Inner,
};
